var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.29 196.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7a7a7a;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke: #000;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #a3a3a3;\n      }\n\n      .cls-10 {\n        fill: #b7b7b7;\n      }\n\n      .cls-5 {\n        fill: #b5b5b5;\n      }\n\n      .cls-11 {\n        fill: #bcbcbc;\n      }\n\n      .cls-6 {\n        fill: #828282;\n      }\n\n      .cls-7 {\n        fill: #5b5757;\n      }\n\n      .cls-12 {\n        opacity: .22;\n      }\n\n      .cls-8 {\n        fill: #c4c4c4;\n      }\n\n      .cls-9 {\n        fill: #666;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M301.54,158.11v-19.92s-60.42-19.34-60.42-19.34v-22.14s-36.05-12.89-36.05-12.89l16.1-1.75,5.08-1.61-3.8-21.39-2.99.02s-1.62-4.51-2.95-8.86c-.28-1.58.69-12.22.69-12.22l-6.34-11.74.21-4.42,1.58-2.93v-7.03s-13.92-11.13-13.92-11.13L41.18,8.38l-7.51,5.84-5.78,6.76-2.21,10.26,12.97,64.98-28.16,2.99-7.91,7.62-1.58,27.25,32.91,21.46-7.49,1.1v10.55s18.87,11.87,18.87,11.87l22.78,1.31,15.24-2.61s-.39,11.1,16.71,6.71l16.45,9.38,19.93,1.76,165.14-37.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "10.49 99.21 2.58 106.83 1 134.08 33.91 155.55 56.33 151.84 56.33 129.69 50.4 118.83 10.49 99.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.42,156.64v10.55s18.87,11.87,18.87,11.87l22.78,1.31,15.24-2.61s.11,5.68,6.52,7.57,10.19-.86,10.19-.86l16.45,9.38.65-7.33-15.2-7.62-1.16-7.51s-9.42,1.99-10.93,1.52-3.87-2.79,0-5.37l-21.03,2.71-21.85-1.69-20.53-11.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "117.12 186.53 130.08 186.53 136.4 195.62 116.47 193.86 117.12 186.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.89 20.98 25.68 31.24 41.5 105.37 42.62 108.3 53.6 113.87 36.12 18.05 27.89 20.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.23,48.66s.84,5.43,2.11,8.36,4.11,2.05,4.11,2.05l3.8,21.39s.95.88-3.8,1.47-49.35,4.69-54.41,8.79l3.48,24.91s1.9,8.5-3.48,9.38l-100.29,15.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "212.14 27.22 211.06 21.86 212.64 18.93 212.64 11.9 198.72 .76 41.18 8.38 32.32 15.27 27.89 20.98 25.68 31.24 41.81 106.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36.12,
    y1: 18.05,
    x2: 41.18,
    y2: 8.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.32,16l12.34,63.58s2.21,3.22-3.8,4.69c-6.01,1.47-92.06,10.55-92.06,10.55,0,0-6.33,1.47-7.28-4.1-.95-5.57-12.34-68.27-12.34-68.27,0,0,0-3.52,4.75-4.4s91.43-4.83,91.43-4.83c0,0,4.43-1.03,6.96,2.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "47.19 22.45 143.99 18.05 156.65 81.05 59.53 91.41 47.19 22.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "205.07 83.82 241.12 96.28 185.75 103.61 168.04 97.75 54.91 110.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.12,96.28v22.56s60.42,19.34,60.42,19.34v19.92s-165.14,37.51-165.14,37.51l-19.93-1.76-16.45-9.38s-1.58,2.93-10.12.88c-8.54-2.05-6.33-12.01-6.33-12.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.75,
    y1: 103.61,
    x2: 185.75,
    y2: 127.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 228.77,
    y1: 92.01,
    x2: 176.13,
    y2: 100.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.29,
    y1: 106.83,
    x2: 63.96,
    y2: 120.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.52,
    y1: 115.62,
    x2: 67.75,
    y2: 129.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.83,
    y1: 119.43,
    x2: 67.75,
    y2: 134.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "66.49 125 58.89 115.62 169.59 101.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 58.89,
    y1: 115.62,
    x2: 36.12,
    y2: 105.37
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "38.65 96.22 10.49 99.21 51.62 119.43 56.36 127.64 56.41 152.25 26.42 156.64 26.42 167.19 45.29 179.07 68.07 180.38 83.41 177.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10.49 99.21 2.58 106.83 1 134.08 33.91 155.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.4,
    y1: 153.13,
    x2: 1.29,
    y2: 126.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.64,18.93s-17.4-1.47-24.04,3.52-8.54,12.6-6.33,21.1c2.21,8.5,10.12,17.87,23.41,17.29,5.38.03,7.3-5.41,7.3-5.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.46,59.1l3.62,19.31-52.79,7.62s-2.25,1.69-2.25,4.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "238.9 119.43 238.9 99.51 188.07 105.37 188.07 127.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "236.16 107.18 221.4 109.43 221.4 107.18 206.21 108.3 206.21 111.19 189.55 113.41 189.55 115.62 206.84 113.87 207.27 115.62 222.03 114.74 221.82 111.4 236.16 109.08 236.16 107.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "238.9 113.87 236.16 113.87 236.16 111.4 224.35 113.57 224.35 115.62 189.55 120.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "213.49 86.73 168.04 93.71 51.93 106.83 36.12 18.05 27.89 20.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216.55,
    y1: 93.79,
    x2: 194.38,
    y2: 85.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 197.19,
    y1: 97.06,
    x2: 179.52,
    y2: 87.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.54,
    y1: 147.27,
    x2: 261.68,
    y2: 155.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.54 143.46 261.68 151.08 261.68 163.38 181.39 180.38 181.39 168.37 130.07 176.28 119.79 176.28 101.92 167.96 101.92 178.91 117.12 186.53 130.07 186.53 130.07 180.38 181.39 172.32 261.68 155.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "181.39 168.37 176.13 163.73 255.35 148.73 261.68 151.08 181.39 168.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "203.68 65.91 206.63 68.45 207.48 74.91 189.55 76.65 188.07 66.69 203.68 65.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "215.35 64.74 217.81 68.64 217.81 74.91 210.85 74.91 210.85 69.43 208.53 64.74 215.35 64.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 217.81,
    y1: 68.64,
    x2: 210.85,
    y2: 68.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "178.35 6.17 179.29 10.69 171.56 11.04 170.76 6.51 178.35 6.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "189.44 5.67 190.38 10.2 182.66 10.54 181.86 6.02 189.44 5.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.02 5.2 200.96 9.72 193.24 10.07 192.44 5.54 200.02 5.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.49 11.78 202.43 16.3 194.71 16.65 193.91 12.12 201.49 11.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "179.82 12.76 180.76 17.28 173.03 17.62 172.23 13.1 179.82 12.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "190.77 12.26 191.71 16.79 183.99 17.13 183.19 12.61 190.77 12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M185.14,43.42c2.63,9.84,11.85,16.2,20.59,14.2,8.74-2,13.69-11.61,11.06-21.45-2.63-9.84-11.85-16.2-20.59-14.2-8.74,2-13.69,11.61-11.06,21.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 196.2,
    y1: 21.97,
    x2: 188.6,
    y2: 22.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 205.73,
    y1: 57.62,
    x2: 194.72,
    y2: 58.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M202.78,34.26c1.08,2.35,3.73,3.56,5.92,2.69s3.1-3.47,2.02-5.82c-1.08-2.35-3.73-3.56-5.92-2.69s-3.1,3.47-2.02,5.82Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "119.79 176.28 117.12 178.62 117.12 186.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.92,171s-9.17,3.52-13.6,1.47c-4.43-2.05,5.38-7.47,5.38-7.47l-27.21-12.75v-27.25s103.8-14.01,103.8-14.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "89.83 167.57 67.75 170.42 68.07 180.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "67.75 170.42 46.95 168.59 46.95 178.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.95,
    y1: 168.59,
    x2: 26.42,
    y2: 156.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.01,
    y1: 151.14,
    x2: 90.56,
    y2: 165.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "68.8 154.12 36.69 159.61 31.34 155.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "74.12 156.87 42.62 162.62 36.69 159.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "80.18 159.99 48.52 166.12 42.62 162.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "85.29 162.62 62.16 167.57 57.35 164.41 47.67 157.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "73.13 165.09 69.6 162.04 65.32 158.47 62.16 155.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.44 139.86 278.03 134.47 259.89 137.5 277.18 143.46 294.44 139.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "286.12 141.82 277.92 138.38 278.03 134.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 269.64,
    y1: 140.86,
    x2: 277.92,
    y2: 138.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "295.43 139.62 295.43 141.82 277.16 145.8 257.67 138.97 258.47 137.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.22,
    y1: 130.06,
    x2: 110.04,
    y2: 154.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 239.92,
    y1: 125.68,
    x2: 97.75,
    y2: 150.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,123.32l22.63,8.86-137.13,24.81-26.43-10.58,140.93-23.09M231.94,121.78l-146.66,24.03,31.84,12.75,142.77-25.83-27.95-10.94h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 240.48,
    y1: 134.87,
    x2: 218.07,
    y2: 125
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 227.72,
    y1: 137.19,
    x2: 205.52,
    y2: 127.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215.8,
    y1: 140.69,
    x2: 190.39,
    y2: 128.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 197.19,
    y1: 142.94,
    x2: 177.87,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 183.77,
    y1: 145.1,
    x2: 162.95,
    y2: 134.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.37,
    y1: 148.73,
    x2: 147.89,
    y2: 136.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.72,
    y1: 138.91,
    x2: 157.47,
    y2: 150.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 142.05,
    y1: 152.68,
    x2: 120.84,
    y2: 141.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 128.08,
    y1: 155.2,
    x2: 100.76,
    y2: 143.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "85.29 145.8 84.81 151.41 115.42 162.65 117.12 158.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "159.63 156.2 144.05 158.55 137.98 156.64 152.54 153.68 159.63 156.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "159.63 156.2 163.06 160.32 146.09 163.05 134 160.32 115.42 162.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 137.98,
    y1: 156.64,
    x2: 134,
    y2: 160.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 144.05,
    y1: 158.55,
    x2: 146.09,
    y2: 163.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "259.89 132.72 259.89 137.5 246.49 140.04 242.48 137.89 158.47 153.68 165.51 155.55 246.53 140.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "246.49 140.04 246.49 144.49 163.06 160.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 165.51,
    y1: 155.55,
    x2: 164.8,
    y2: 159.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.7,
    y1: 154.06,
    x2: 157.43,
    y2: 155.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.89 119.43 50.07 130.59 50.07 148.73 26.42 137.19 27.89 119.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.25,
    y1: 105.37,
    x2: 19.14,
    y2: 135.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "122.65 139.68 119.16 136.69 86.07 142.05 89.6 145.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M300.54,158.14v-19.92s-60.42-19.34-60.42-19.34v-22.14s-36.05-12.89-36.05-12.89l16.1-1.75,5.08-1.61-3.8-21.39-2.99.02s-1.62-4.51-2.95-8.86c-.28-1.58.69-12.22.69-12.22l-6.34-11.74.21-4.42,1.58-2.93v-7.03s-13.92-11.13-13.92-11.13L40.18,8.41l-7.51,5.84-5.78,6.76-2.21,10.26,12.97,64.98-28.16,2.99-7.91,7.62-1.58,27.25,32.91,21.46-7.49,1.1v10.55s18.87,11.87,18.87,11.87l22.78,1.31,15.24-2.61s-.39,11.1,16.71,6.71l16.45,9.38,19.93,1.76,165.14-37.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.6688e5919acb4d6eb0ecaf02f91e28ef.svg";
export { ForwardRef as ReactComponent };